<template>

  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >

  <v-dialog v-model="dialogFormUser" persistent max-width="600px">
    <v-form ref="form" @submit.prevent="simpanData()">
      <v-card>
        <v-card-title v-if="edit == false">
            Tambah Data Pemasukan
        </v-card-title>
        <v-card-title v-else>
            Edit Pemasukan
        </v-card-title>
        <v-card-text>
          <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  
                  <datepicker label="Tanggal"  :rules="rules.tanggal"  v-model="stgl" required></datepicker>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                <v-combobox :items="jenisku" label="Jenis" :rules="rules.jenis"  v-model="jenis" required></v-combobox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-textarea label="Keterangan" auto-grow rows="1" v-model="ket"  :rules="rules.ket" required></v-textarea>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field class="right" label="Pemasukan (Rp)" v-model="jumlah" :rules="rules.jumlah"  type="number" required></v-text-field>
                </v-col>
              </v-row>

          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="close()">Close</v-btn>
            <v-btn color="blue darken-1" type="submit" text >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>

 
     
 <div class="mx-3"     >
      <v-container fluid >
        <v-card class="px-4 py-2 mt-1">
          <v-row>
            <v-col cols="12" md="9" sm="6">
              <v-btn color="primary" class="mr-3" @click="dialogFormUser = true; edit = false"><v-icon class="mr-1">mdi-plus</v-icon>Add</v-btn>
              <v-btn color="primary" class="mr-3" @click="dialogFormUser = true; edit = true ; ediddata()" :disabled="selected.length > 1 || !selected.length"><v-icon class="mr-1">mdi-pencil</v-icon>Edit</v-btn>
              <v-btn color="primary" @click="deleteItem()" :disabled="!selected.length"><v-icon class="mr-1">mdi-delete</v-icon>Delete</v-btn>
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field v-model="search" class="pa-0" append-icon="mdi-magnify" label="Cari data" hide-details clearable/>
            </v-col>
          </v-row>
        </v-card>
      </v-container>

      <v-container fluid >
         <v-card class="mt-4">
          <!-- <v-data-table :headers="headers"     :items="dataitems" :server-items-length="10" :items-per-page.sync="itemsPerPage" :page.sync="pageSync" v-model="selected"  show-select  -->
          <v-data-table :headers="headers"     :items="dataitems"   v-model="selected"  show-select  
                :single-select="true" item-key="no" disable-sort class="elevation-1">
          </v-data-table>
        </v-card>
      </v-container>
       
      
    </div>  
  </v-container>
  
</template>

<script>

import { mapActions, mapState } from 'vuex';
import datepicker from '@/components/datepicker'
export default {
  name: 'pemasukan',
  components:{
    datepicker,
  },
  data(){
    return {
      edit: false,
      dialogFormUser: false,
      dialogConfirm: false,
      historidetail:false,
      editserial: false,
      alasanRules: [
      v => !!v || 'Alasan is required',
      ],
      jenisku:['Transport','Komisi Reseller','Jasa','Gaji','Lain-lain'],
      itemsPerPage: 15,
      selected:[],
      pageSync:1,
      searchTimeout: null,
      search:'',
      headers:[
        {text:'pk',value:'no', align: ' d-none' },
        {text:'Tanggal', value:'tgl', },
        {text:'Jenis', value:'jenis', },
        {text:'Keterangan', value:'ket', },
        {text:'Jumlah', value:'jml', },
        {text:'nilai',value:'masuk', align: ' d-none' },
      ],
      pk:'',
      stgl:'',
      tgl:'',
      jenis:'',
      ket:'',
      jumlah:0,

      rules:{
        tanggal: [
          v => !!v || 'Tanggal tidak boleh kosong!',
        ],
        jenis: [
          v => !!v || 'Jenis tidak boleh kosong!',
        ],
        ket:[
          v =>  !!v || 'Keterangan tidak boleh kosong!',
        ],
        jumlah:[
          v=> !!v || 'Jumlah tidak boleh kosong',
        ],
      },

      
      
      
      dataitem :[
        {jenis: "Biaya",
        jml: "20000",
        ket: "Biaya Swa",
        no: "1",
        tgl: "0000-00-00"},

        {jenis: "Biaya",
        jml: "20000",
        ket: "Biaya Swa",
        no: "2",
        tgl: "0000-00-00"},
      ],

      dataitems:[],


    }
  },

  created(){
    const date = new Date();
    const month = date.getMonth() + 1;

    this.stgl = `${date.getDate() <= 9 ? 0 : ''}${date.getDate()}/${month <= 9 ? 0 : ''}${month}/${date.getFullYear()}`;
    // console.log('tangga',this.stgl)


    this.loadpemasukan();
    this.tgl=this.stgl;
    console.log('tanggal',this.tgl)
  },
  computed : {
    ...mapState(['API_URL']),
    ...mapState('pemasukan',['dataMasuk']),

  },
  methods :{
    ...mapActions('pemasukan',['getPemasukan','addPemasukan','deletePemasukan','editPemasukan']),
    
    alertNotif(title, type, text) {
      this.$swal({
        heightAuto: false,
        title,
        type,
        text,
        // showCancelButton: showcancel,
        // confirmButtonClass: "btn-danger",
      });
    },
    ediddata(){
      this.pk=this.selected.map(x => x.no);
      this.stgl=this.selected.map(x => x.tgl);
      this.ket= this.selected.map(x => x.ket);
      this.jumlah =this.selected.map(x => x.masuk);
      this.jenis=this.selected.map(x => x.jenis);
      console.log('nilai pk',this.pk);
    },

    deleteItem() {
      this.$swal ({
        text:'Anda yakin menghapus data pemasukan : ' + this.selected.map(x => x.ket) + '?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Tidak',
        confirmButtonText: 'Ya',
      }).then ((result)=>{
        if (result){
          const param =new FormData();
          param.append('pk',this.selected.map(x=>x.no));
          this.deletePemasukan(param).then((res)=>{
            if (res.success) {
              this.alertNotif('Berhasil','success','Data berhasil dihapus!');
              this.loadpemasukan();
            }else{
              //gagag; hapus
              this.alertNotif('Berhasil','warning','Data tidak berhasil dihapus!');
            }
          });
        }
      });

    },

    close() {
        this.dialogFormUser=false;
        this.$emit('input', false)
        this.$refs.form.reset()
        setTimeout(() => this.$refs.form.resetValidation(), 500)
        
      },
     
    simpanData(){
      const valid = this.$refs.form.validate()
      if (!valid) return;

      this.dialogFormUser=false;
      const param  = new FormData();
      param.append('tgl',this.stgl);
      param.append('jenis',this.jenis);
      param.append('ket',this.ket);
      param.append('jml',this.jumlah);
      param.append('user',this.$cookies.get('user'));
      
      if (this.edit==true ){
        console.log('nilai pk',this.pk[0])
        param.append('pk',this.pk[0]);
        this.editPemasukan(param).then((res)=>{
          if (res.success){
              this.alertNotif("Berhasil",'success','Data Berhasil disimpan');
              this.close();
              this.loadpemasukan();
          }else{
            this.alertNotif("Gagal",'warning','Gagal Disimpan');
          }
        });
      }else{
        this.addPemasukan(param).then((res)=>{
          if (res.success){
              this.alertNotif("Berhasil",'success','Data Berhasil disimpan');
              this.close();
              this.loadpemasukan();
          }else{
            this.alertNotif("Gagal",'warning','Gagal Disimpan');
          }
        });

      }
      
    },
    
     

    async loadpemasukan(){
      const param=new FormData();
      param.append('filter','');
      param.append('tgl','');
      await this.getPemasukan(param) ;
      this.dataitems=this.dataMasuk;
      console.log('data setelah loadpemasukan',this.dataitems);
      

    },


  },
}
</script>
